<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default { name: 'App' }
</script>

<style>
html, body, #app { height: 100%; margin: 0; padding: 0; }

/* 列表页表格单元格内容水平居中(表头 + 数据) */
.el-table .cell {
  text-align: center;
}
</style>
